// Shopify enforces a 40-character maximum per order/draft-order tag, inclusive (a 40-char tag is allowed; 41+ is rejected).
// Source: https://help.shopify.com/en/manual/products/details/tags ("Tags that are associated with orders and draft orders can have up to 40 characters.")
const SHOPIFY_ORDER_TAG_MAX_LENGTH = 40;

const LOOKBOOK_ORDER_TAG_SUFFIX = ' Lookbook';
const MAX_LOOKBOOK_TITLE_LENGTH_FOR_ORDER_TAG = SHOPIFY_ORDER_TAG_MAX_LENGTH - LOOKBOOK_ORDER_TAG_SUFFIX.length;

const getLookbookOrderTag = lookbookTitle => `${lookbookTitle}${LOOKBOOK_ORDER_TAG_SUFFIX}`;

module.exports = {
  SHOPIFY_ORDER_TAG_MAX_LENGTH,
  MAX_LOOKBOOK_TITLE_LENGTH_FOR_ORDER_TAG,
  getLookbookOrderTag
};
